import { isEmpty } from 'lodash';

const containsEmptyElements = (array) => {
  if (array.includes('')) {
    return true;
  }
  return false;
};

const removeEmptyItems = (array) => {
  const filterArray = array.filter((item) => !isEmpty(item));
  return filterArray;
};

module.exports = {
  containsEmptyElements,
  removeEmptyItems,
};
